class CookieService {
  getCookie (name: string) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  deleteCookie (name: string) {
    document.cookie = `${name}=; Max-Age=0; path=/;`
  }

  setCookie (name: string, value: string, path: string = '/') {
    document.cookie = `${name}=${value}; path=${path}`
  }
}

export const cookieService = new CookieService()
